import { MonitorAddLocationSelectable, MonitorIdentifier } from 'app/shared/models/monitorsetting';
import { BaseMonitorSeriesValues } from '../../location-card.constants';

export const BASE_MONITOR_SERIES: MonitorAddLocationSelectable[] = [
    {
        monitorSeriesID: MonitorIdentifier.Echo,
        value: BaseMonitorSeriesValues.ECHO,
        text: 'COMMON.TEST_ECHO',
    },
    {
        monitorSeriesID: MonitorIdentifier.EdgeDx,
        value: BaseMonitorSeriesValues.EDGE_DX,
        text: 'COMMON.EDGE_DX',
    },
    {
        monitorSeriesID: MonitorIdentifier.EdgeRl,
        value: BaseMonitorSeriesValues.EDGE_RL,
        text: 'COMMON.EDGE_RL',
    },
    {
        monitorSeriesID: MonitorIdentifier.TritonPlus,
        value: BaseMonitorSeriesValues.FLEX,
        text: 'COMMON.TEST_FLEX',
    },
    {
        monitorSeriesID: MonitorIdentifier.ForeSITE_UL,
        value: BaseMonitorSeriesValues.FORESITE_UL,
        text: 'COMMON.TEST_ForeSITE_UL',
    },
    {
        monitorSeriesID: MonitorIdentifier.ForeSITE_XD,
        value: BaseMonitorSeriesValues.FORESITE_XD,
        text: 'COMMON.TEST_ForeSITE_XD',
    },
    {
        monitorSeriesID: MonitorIdentifier.TritonPlus,
        value: BaseMonitorSeriesValues.GENERIC_MONITOR,
        text: 'COMMON.GENERIC_MONITOR',
    },
    {
        monitorSeriesID: MonitorIdentifier.RainAlertIII,
        value: BaseMonitorSeriesValues.RAINALERT_III,
        text: 'COMMON.TEST_RAIN',
    },
    {
        monitorSeriesID: MonitorIdentifier.TritonPlus,
        value: BaseMonitorSeriesValues.TRITON_PLUS,
        text: 'COMMON.TEST_TRI',
    },
];
